import React from 'react';

const GenderFilterIcon = (props: any) => (
  <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
    <circle cx="11" cy="9" r="4.25" strokeWidth="1.5" />
    <circle cx="7" cy="9" r="4.25" strokeWidth="1.5" />
    <path d="M14.5 2.5H17.5V5.5" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />
    <path d="M17 3L14 6" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />
    <path d="M7 13.5V17.5" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />
    <path d="M5.5 15.5H8.5" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />
  </svg>
);

export default GenderFilterIcon;
